import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export default function ChangePasswordForcedModal() {
  const { user, checkAuth } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user || !user.must_change_password) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("Le nouveau mot de passe doit faire au moins 6 caractères");
    if (next !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Mot de passe mis à jour");
      await checkAuth();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec du changement de mot de passe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[4000] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="force-password-modal">
      <div className="glass rounded-xl w-full max-w-md p-6 border border-[#F5821F]/50 animate-slidein">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-9 h-9 rounded-full bg-[#F5821F] flex items-center justify-center"><KeyRound className="w-4 h-4 text-white" /></div>
          <h2 className="text-lg font-bold">Changez votre mot de passe</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-4">Première connexion : pour votre sécurité, définissez un nouveau mot de passe.</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="label-mono">Mot de passe provisoire (reçu par email)</label>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="fp-current"
              className="w-full mt-1 bg-black/20 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#17A2B8]/60" />
          </div>
          <div>
            <label className="label-mono">Nouveau mot de passe</label>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="fp-new"
              className="w-full mt-1 bg-black/20 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#17A2B8]/60" />
          </div>
          <div>
            <label className="label-mono">Confirmer le nouveau mot de passe</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="fp-confirm"
              className="w-full mt-1 bg-black/20 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#17A2B8]/60" />
          </div>
          <button type="submit" disabled={busy} data-testid="fp-submit"
            className="w-full bg-[#17A2B8] hover:bg-[#1391a5] text-white font-semibold py-2.5 rounded-md flex items-center justify-center gap-2 disabled:opacity-50">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Valider et continuer
          </button>
        </form>
      </div>
    </div>
  );
}
